import React from "react";
import { CategoryIcon, SettingIcon } from "./components/atoms/icon";
import ApprovalWorkflow from "./components/pages/approval-workflow";
import ForgotPassword from "./components/pages/auth-module/forgot-password";
import ResetPassword from "./components/pages/auth-module/reset-password";
import SignIn from "./components/pages/auth-module/sign-in";
import SignUp from "./components/pages/auth-module/sign-up";
import BBALM from "./components/pages/bb-alm";
import EcapDashboardComponent from "./components/pages/dashboard";
import ECAPLeader from "./components/pages/ecap-Leader";
import ECAPLeaderOnboarding from "./components/pages/ecap-Leader/onboarding";
import EcapModule from "./components/pages/ecap-module";
import EcapReports from "./components/pages/ecap-module/list-report";
import EcapNewReport from "./components/pages/ecap-module/new-report";
import EcapReportDetails from "./components/pages/ecap-module/report-details";
import EcapModuleReportGroup from "./components/pages/ecap-module/report-group";
import ERMModule from "./components/pages/erm-module";
import ControlFailures from "./components/pages/erm-module/control-failures";
import ControlFailureForm from "./components/pages/erm-module/control-failures/form";
import ControlFailureView from "./components/pages/erm-module/control-failures/view";
import Scenarios from "./components/pages/erm-module/scenarios";
import AppraisalForm from "./components/pages/erm-module/scenarios/appraisal/form";
import AppraisalView from "./components/pages/erm-module/scenarios/appraisal/view";
import ScenariosForm from "./components/pages/erm-module/scenarios/form";
import ScenrarioInvite from "./components/pages/erm-module/scenarios/invite";
import ScenarioMitigationForm from "./components/pages/erm-module/scenarios/mitigation/form";
import ScenarioMitigationView from "./components/pages/erm-module/scenarios/mitigation/view";
import ScenarioView from "./components/pages/erm-module/scenarios/view";
import FundTransferPricing from "./components/pages/bb-alm/funds-transfer-pricing";
import HomePage from "./components/pages/home/home";
import OnBoarding from "./components/pages/onboarding";
import ProfitabilityKPIModule from "./components/pages/profitability-kpi";
import ProfitabilityKPIOnboarding from "./components/pages/profitability-kpi/onboarding";
import ScenarioFrontier from "./components/pages/scenario-frontier";
import ScenarioFrontierApprovalWorkflow from "./components/pages/scenario-frontier/approval-workflow";
import ScenarioFrontierConfiguration from "./components/pages/scenario-frontier/configuration";
import ScenarioFrontierReports from "./components/pages/scenario-frontier/list-report";
import FrontierNewReport from "./components/pages/scenario-frontier/new-report";
import FrontierReportDetails from "./components/pages/scenario-frontier/report-details";
import FrontierSelectPeriod from "./components/pages/scenario-frontier/select-period";
import ComingSoonPage from "./components/pages/coming-soon";
import { ROUTE_DYNAMIC_VARIABLE, ROUTE_PATHS } from "./constants/url-config";
import i18n from "./utils/i18n";
import { PERMISSION } from "./utils/role-guard";
import BBALMDashboard from "./components/pages/bb-alm/dashboard";
import AssetLiability from "./components/pages/bb-alm/asset-liability";
import StaticALM from "./components/pages/bb-alm/asset-liability/static-alm";
import DynamicALM from "./components/pages/bb-alm/asset-liability/dynamic-alm";
import StressTesting from "./components/pages/bb-alm/asset-liability/stress-testing";
import Liquidity from "./components/pages/bb-alm/liquidity";
import BBALMALCO from "./components/pages/bb-alm/ALCO-reporting";
import BCAR from "./components/pages/bb-alm/BCAR";
import Investments from "./components/pages/bb-alm/investments";
import FPF from "./components/pages/bb-alm/FPF";
import TrendAnalysis from "./components/pages/bb-alm/FPF/trend-analysis";
import GrowthAssumptions from "./components/pages/bb-alm/FPF/growth-assumptions";
import RateAssumptions from "./components/pages/bb-alm/FPF/rate-assumptions";
import IncomeExpenseAssumptions from "./components/pages/bb-alm/FPF/income-expense-assumptions";
import BalanceSheetForecast from "./components/pages/bb-alm/FPF/balance-sheet-forecast";
import IncomeStatementForecast from "./components/pages/bb-alm/FPF/income-statement-forecast";
import VarianceAnalysis from "./components/pages/bb-alm/FPF/variance-analysis";
import ERMStressTesting from "./components/pages/bb-erm/stress-testing";
import BBMRM from "./components/pages/bb-mrm";


export interface Route {
  groupIndex?: number;
  href?: string;
  exact?: boolean;
  component?: any;
  title?: string;
  hidden?: boolean;
  icon?: JSX.Element;
  forAdmin?: boolean;
  loginRequired?: boolean;
  permissions?: PERMISSION[];
  id?: number;
  parentId?: number;
  showOnMenu?: boolean;
  hideBreadcrumb?: boolean;
  menuName?: string;
}

export enum RoutingEnum {
  Home = 1,
  Onboarding,
  AllApplications,
  Cyber360,
  ECAPLeader,
  ApprovalWorkflow,
  Dashboard,
  ECAPModule,
  ModelTek,
  ProfitabilityKPI,
  ProfitabilityKPIOnboarding,
  FTPCalculator,
  PortfolioRAROCModule,
  StandaloneCorporate,
  StandaloneMortgage,
  ProfitabilityDashboard,
  ScenarioFrontier,
  ScenarioFrontierApprovalWorkflow,
  ScenarioFrontierReviewReport,
  ScenarioFrontierScenarioAndBudgeting,
  ScenarioFrontierAssetQuality,
  ScenarioFrontierCreditandConcentration,
  ScenarioFrontierIFRSCECL,
  ScenarioFrontierRiskAppetiteDashboard,
  ScenarioFrontierReports,
  ScenarioFrontierNewReport,
  ScenarioFrontierUpdateReport,
  ScenarioFrontierReportDetails,
  Scenarios,
  AddScenario,
  ControlFailure,
  AddControlFailure,
  EditControlFailure,
  ViewControlFailure,
  ScenrarioInvite,
  ViewScenario,
  ScenarioMitigation,
  ScenarioAppraisal,
  EditScenario,
  ApprovalWorkflowMitigation,
  ApprovalWorkflowAppraisal,
  ApprovalWorkflowScenario,
  ApprovalWorkflowControlFalure,
  ScenarioMitigationView,
  ScenarioAppraisalView,
  PortfolioRAROCNewReport,
  PortfolioRAROCReportDetails,
  ApprovalWorkflowPortfolioRAROC,
  EcapReports,
  EcapNewReport,
  ECAPReportGroup,
  EcapReportDetails,
  ApprovalWorkflowEcapModule,
  EcapLearderOnboarding,
  ScenarioFrontierConfiguration,
  BBALM,
  ScenariosAndFinancial,
  financialAnalysisOptimization,
  FundsTransferPricing,

  AssetLiability,
  StrategicIFRS,
  BBALMStressTesting,
  StaticAlm,
  DynamicAlm,
  StressTesting,

  Liquidity,
  RegulatoryLCR,
  OperationalLCR,
  NetStableFundingRatio,
  NetCumulativeCashFlowRatio,

  financialPlaning_and_forecasts,
  TrendAnalysis,
  GrowthAssumptions,
  RateAssumptions,
  TermAssumptions,
  ShockSensitivity,
  IncomeExpenseAssumptions,
  BalanceSheetForecast,
  IncomeStatementForecast,
  VarianceAnalysis,

  capital_adequacy_ratio,
  CreditRiskCapitalization,
  OperationalRiskCapitalization,
  CapitalStressTesting,

  CreditScoring,
  Investments,
  AverageLifeAnalysis,
  ValueatRiskAnalysis,

  securitization,

  BBALMReporting,
  ALCODashboard,
  ALCOReport,

  BBERM,
  BBERM_Strategic_IFRS9,
  BBERM_Scenario_Asset_Planning,
  BBERM_StressTesting,
  BBERM_KRI_KCI_Repo,

  BBMRM,
  ModelsRepository,
  ParametricTesting,
  ChallengerModelTesting,
  InterestRiskModelTesting,
}

export const anonymousRouters: Route[] = [
  {
    href: ROUTE_PATHS.SignIn,
    exact: true,
    component: SignIn,
    hidden: true,
    permissions: [],
  },
  {
    href: ROUTE_PATHS.ForgotPassword,
    exact: true,
    component: ForgotPassword,
    permissions: [],
  },
  {
    href: `${ROUTE_PATHS.ResetPassword}/${ROUTE_DYNAMIC_VARIABLE.token}`,
    exact: true,
    component: ResetPassword,
    permissions: [],
  },
  {
    href: ROUTE_PATHS.SignUp,
    exact: true,
    component: SignUp,
    permissions: [],
  },
];

export const authorizedRouters: Route[] = [
  {
    href: ROUTE_PATHS.Home,
    exact: true,
    title: i18n.t("Menu.enterpriseApplications"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.Home,
    showOnMenu: true,
    icon: <CategoryIcon />,
    hideBreadcrumb: true,
  },
  {
    href: ROUTE_PATHS.Onboarding,
    exact: true,
    title: i18n.t("Onboarding.ttConfiguration"),
    permissions: [PERMISSION.ClientAdmin],
    loginRequired: true,
    id: RoutingEnum.Onboarding,
    showOnMenu: true,
    icon: <SettingIcon />,
    component: OnBoarding,
    hideBreadcrumb: true,
  },
  {
    href: ROUTE_PATHS.Home,
    exact: true,
    component: HomePage,
    title: i18n.t("Menu.enterpriseApplications"),
    menuName: i18n.t("Menu.allApplications"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.AllApplications,
    showOnMenu: false,
    parentId: RoutingEnum.Home,
    hideBreadcrumb: true,
  },
  // {
  //     id: RoutingEnum.Cyber360,
  //     title: i18n.t('Menu.cyber360'),
  //     parentId: RoutingEnum.Home,
  //     showOnMenu: true
  // },

  ///////////
  ///////////
  /// BBALM ///
  ///////////
  ///////////
  {
    href: ROUTE_PATHS.BBALM,
    exact: true,
    component: BBALM,
    title: i18n.t("BBALM.headerTitle"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.BBALM,
    parentId: RoutingEnum.Home,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.Liquidity,
    exact: true,
    component: Liquidity,
    title: i18n.t("BBALM.liquidity"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.Liquidity,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.RegulatoryLCR,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.regulatoryLCR"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.RegulatoryLCR,
    parentId: RoutingEnum.Liquidity,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.OparationalLCR,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.operationalLCR"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.OperationalLCR,
    parentId: RoutingEnum.Liquidity,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.NetStableFundingRatio,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.netStableFundingRatio"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.NetStableFundingRatio,
    parentId: RoutingEnum.Liquidity,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.NetCumulativeCashFlowRatio,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.netCumulativeCashFlowRatio"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.NetCumulativeCashFlowRatio,
    parentId: RoutingEnum.Liquidity,
    showOnMenu: true,
  },

  {
    href: ROUTE_PATHS.FinancialPlanningForecasts,
    exact: true,
    component: FPF,
    title: i18n.t("BBALM.financialPlanningForecasts"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.financialPlaning_and_forecasts,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.TrendAnalysis,
    exact: true,
    component: TrendAnalysis,
    title: i18n.t("BBALM.trendAnalysis"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.TrendAnalysis,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.GrowthAssumptions,
    exact: true,
    component: GrowthAssumptions,
    title: i18n.t("BBALM.growthAssumptions"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.GrowthAssumptions,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.RateAssumptions,
    exact: true,
    component: RateAssumptions,
    title: i18n.t("BBALM.rateAssumptions"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.RateAssumptions,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.TermAssumptions,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.termAssumptions"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.TermAssumptions,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.ShockSensitivity,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.shockSensitivity"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ShockSensitivity,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.IncomeExpenseAssumptions,
    exact: true,
    component: IncomeExpenseAssumptions,
    title: i18n.t("BBALM.incomeExpenseAssumptions"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.IncomeExpenseAssumptions,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.BalanceSheetForecast,
    exact: true,
    component: BalanceSheetForecast,
    title: i18n.t("BBALM.balanceSheetForecast"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.BalanceSheetForecast,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.IncomeStatementForecast,
    exact: true,
    component: IncomeStatementForecast,
    title: i18n.t("BBALM.incomeStatementForecast"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.IncomeStatementForecast,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.VarianceAnalysis,
    exact: true,
    component: VarianceAnalysis,
    title: i18n.t("BBALM.varianceAnalysis"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.VarianceAnalysis,
    parentId: RoutingEnum.financialPlaning_and_forecasts,
    showOnMenu: true,
  },

  {
    href: ROUTE_PATHS.CapitalAdequacyRatio,
    exact: true,
    component: BCAR,
    title: i18n.t("BBALM.capitalAdequacyRatio"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.capital_adequacy_ratio,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.CreditRiskCapitalization,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.creditRiskCapitalization"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.CreditRiskCapitalization,
    parentId: RoutingEnum.capital_adequacy_ratio,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.OperationalRiskCapitalization,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.operationalRiskCapitalization"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.OperationalRiskCapitalization,
    parentId: RoutingEnum.capital_adequacy_ratio,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.CapitalStressTesting,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.capitalStressTesting"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.CapitalStressTesting,
    parentId: RoutingEnum.capital_adequacy_ratio,
    showOnMenu: true,
  },

  {
    href: ROUTE_PATHS.Investments,
    exact: true,
    component: Investments,
    title: i18n.t("BBALM.investments"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.Investments,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.AverageLifeAnalysis,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.averageLifeAnalysis"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.AverageLifeAnalysis,
    parentId: RoutingEnum.Investments,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.ValueatRiskAnalysis,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.valueAtRiskAnalysis"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ValueatRiskAnalysis,
    parentId: RoutingEnum.Investments,
    showOnMenu: true,
  },

  {
    href: ROUTE_PATHS.Securitization,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.securitization"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.securitization,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.FundsTransferPricing,
    exact: true,
    component: FundTransferPricing,
    title: i18n.t("BBALM.marginManagementFtp"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.FundsTransferPricing,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },

  {
    href: ROUTE_PATHS.BBALMALCO,
    exact: true,
    component: BBALMALCO,
    title: i18n.t("BBALM.alcoReporting"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.BBALMReporting,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.ALCODashboard,
    exact: true,
    component: BBALMDashboard,
    title: i18n.t("BBALM.dashboard"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ALCODashboard,
    parentId: RoutingEnum.BBALMReporting,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.ALCOReport,
    exact: true,
    component: ComingSoonPage,
    title: i18n.t("BBALM.report"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ALCOReport,
    parentId: RoutingEnum.BBALMReporting,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.AssetLiability,
    exact: true,
    component: AssetLiability,
    title: i18n.t("BBALM.assetLiabilityManagement"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.AssetLiability,
    parentId: RoutingEnum.BBALM,
    showOnMenu: true,
  },
  {
    href: ROUTE_PATHS.StaticALM,
    exact: true,
    component: StaticALM,
    title: i18n.t("AssetLiability.staticALM"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.StaticAlm,
    parentId: RoutingEnum.AssetLiability,
    showOnMenu: false,
  },
  {
    href: ROUTE_PATHS.DynamicALM,
    exact: true,
    component: DynamicALM,
    title: i18n.t("AssetLiability.dynamicALM"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.DynamicAlm,
    parentId: RoutingEnum.AssetLiability,
    showOnMenu: false,
  },
  {
    href: ROUTE_PATHS.StressTesting,
    exact: true,
    component: StressTesting,
    title: i18n.t("AssetLiability.stressTesting"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.StressTesting,
    parentId: RoutingEnum.AssetLiability,
    showOnMenu: false,
  },
//   {
//     href: ROUTE_PATHS.ScenariosAndFinancial,
//     exact: true,
//     component: ScenarioFrontierConfiguration,
//     title: i18n.t("BBALM.scenariosAndFinancial"),
//     permissions: [],
//     loginRequired: true,
//     id: RoutingEnum.ScenariosAndFinancial,
//     parentId: RoutingEnum.BBALM,
//     showOnMenu: true,
//   },
//   {
//     href: ROUTE_PATHS.FinancialAnalysisOptimization,
//     exact: true,
//     component: ScenarioFrontierConfiguration,
//     title: i18n.t("BBALM.financialAnalysisOptimization"),
//     permissions: [],
//     loginRequired: true,
//     id: RoutingEnum.financialAnalysisOptimization,
//     parentId: RoutingEnum.BBALM,
//     showOnMenu: true,
//   },
//   {
//     href: ROUTE_PATHS.StrategicIFRS,
//     exact: true,
//     component: ScenarioFrontierConfiguration,
//     title: i18n.t("BBALM.strategicIFRS"),
//     permissions: [],
//     loginRequired: true,
//     id: RoutingEnum.StrategicIFRS,
//     parentId: RoutingEnum.BBALM,
//     showOnMenu: true,
//   },
//   {
//     href: ROUTE_PATHS.BBALMStressTesting,
//     exact: true,
//     component: ScenarioFrontierConfiguration,
//     title: i18n.t("BBALM.stressTesting"),
//     permissions: [],
//     loginRequired: true,
//     id: RoutingEnum.BBALMStressTesting,
//     parentId: RoutingEnum.BBALM,
//     showOnMenu: true,
//   },

  ///////////
  ///////////
  /// ERM ///
  ///////////
  ///////////
  {
    id: RoutingEnum.BBERM,
    title: "BB-ERM",
    parentId: RoutingEnum.Home,
    showOnMenu: true,
    loginRequired: true,
    href: ROUTE_PATHS.ScenarioFrontier,
    component: ScenarioFrontier,
  },
{
  href: ROUTE_PATHS.ScenarioFrontierScenarioAndBudgeting,
  id: RoutingEnum.BBERM_Scenario_Asset_Planning,
  title: i18n.t("BBERM.scenarioAssetPlanning"),
  parentId: RoutingEnum.BBERM,
  showOnMenu: true,
  loginRequired: true,
  component: FrontierSelectPeriod,
},
{
  href: ROUTE_PATHS.BBERM_StressTesting,
  id: RoutingEnum.BBERM_StressTesting,
  title: i18n.t("BBERM.creditConcentrationStressTesting"),
  parentId: RoutingEnum.BBERM,
  showOnMenu: true,
  loginRequired: true,
  component: ERMStressTesting,
},
{
  href: ROUTE_PATHS.CreditScoring,
  exact: true,
  component: ComingSoonPage,
  title: i18n.t("BBERM.creditScoringModels"),
  permissions: [],
  loginRequired: true,
  id: RoutingEnum.CreditScoring,
  parentId: RoutingEnum.BBERM,
  showOnMenu: true,
},
{
  href: ROUTE_PATHS.BBERM_KRI_KCI_Repo,
  id: RoutingEnum.BBERM_KRI_KCI_Repo,
  title: i18n.t("BBERM.kriKciRepository"),
  parentId: RoutingEnum.BBERM,
  showOnMenu: true,
  loginRequired: true,
  component: ComingSoonPage,
},
{
    href: ROUTE_PATHS.StrategicIFRS,
    exact: true,
    component: ScenarioFrontierConfiguration,
    title: i18n.t("BBERM.strategicIfrs"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.BBERM_Strategic_IFRS9,
    parentId: RoutingEnum.BBERM,
    showOnMenu: true,
},
{
    href: ROUTE_PATHS.ERMModule,
    id: RoutingEnum.ScenarioFrontierRiskAppetiteDashboard,
    title: i18n.t("ScenarioFrontier.lbResilienceDashboard"),
    parentId: RoutingEnum.BBERM,
    showOnMenu: true,
    loginRequired: true,
    component: ERMModule,
    permissions: [PERMISSION.ERM],
  },
  {
    id: RoutingEnum.ECAPModule,
    title: i18n.t("Menu.eCAPModule"),
    parentId: RoutingEnum.BBERM,
    showOnMenu: true,
    component: EcapModule,
    href: ROUTE_PATHS.ECAPModule,
    loginRequired: true,
  },
  {
    id: RoutingEnum.Dashboard,
    title: i18n.t("EcapModule.Dashboard"),
    parentId: RoutingEnum.ECAPModule,
    showOnMenu: true,
    component: EcapDashboardComponent,
    exact: true,
    permissions: [],
    loginRequired: true,
    href: ROUTE_PATHS.Dashboard,
  },
  {
    id: RoutingEnum.PortfolioRAROCModule,
    parentId: RoutingEnum.BBERM,
    title: i18n.t("BBERM.loanBookLifetimeIncomeAnalysis"),
    showOnMenu: true,
    component: EcapReports,
    href: ROUTE_PATHS.PortfolioRAROCModule,
    loginRequired: true,
  },
  ///////////
  ///////////
  /// MRM ///
  ///////////
  ///////////
  {
    id: RoutingEnum.BBMRM,
    title: i18n.t("BBMRM.headerTitle"),
    parentId: RoutingEnum.Home,
    showOnMenu: true,
    loginRequired: true,
    href: ROUTE_PATHS.BBMRM,
    component: BBMRM,
  },

  {
    href: ROUTE_PATHS.ModelsRepository,
    id: RoutingEnum.ModelsRepository,
    title: i18n.t("BBMRM.modelsRepository"),
    parentId: RoutingEnum.BBMRM,
    showOnMenu: true,
    loginRequired: true,
    component: ComingSoonPage,
  },
  {
    href: ROUTE_PATHS.ParametricTesting,
    id: RoutingEnum.ParametricTesting,
    title: i18n.t("BBMRM.parametricTesting"),
    parentId: RoutingEnum.BBMRM,
    showOnMenu: true,
    loginRequired: true,
    component: ComingSoonPage,
  },
  {
    href: ROUTE_PATHS.ChallengerModelTesting,
    id: RoutingEnum.ChallengerModelTesting,
    title: i18n.t("BBMRM.challengerModelTesting"),
    parentId: RoutingEnum.BBMRM,
    showOnMenu: true,
    loginRequired: true,
    component: ComingSoonPage,
  },
  {
    href: ROUTE_PATHS.InterestRiskModelTesting,
    id: RoutingEnum.InterestRiskModelTesting,
    title: i18n.t("BBMRM.interestRiskModelTesting"),
    parentId: RoutingEnum.BBMRM,
    showOnMenu: true,
    loginRequired: true,
    component: ComingSoonPage,
  },

  ///////////
  ///////////
  /// ECAP Leader///
  ///////////
  ///////////

  // {
  //   href: ROUTE_PATHS.ECAPLeader,
  //   exact: true,
  //   component: ECAPLeader,
  //   title: i18n.t("ECAPLeader.headerTitle"),
  //   permissions: [],
  //   loginRequired: true,
  //   id: RoutingEnum.ECAPLeader,
  //   parentId: RoutingEnum.Home,
  //   showOnMenu: true,
  // },
  // {
  //   id: RoutingEnum.ApprovalWorkflow,
  //   title: i18n.t("Menu.approvalWorkflow"),
  //   parentId: RoutingEnum.ECAPLeader,
  //   showOnMenu: true,
  //   href: ROUTE_PATHS.ApprovalWorkflow,
  //   exact: true,
  //   component: ApprovalWorkflow,
  //   permissions: [PERMISSION.Approver],
  //   loginRequired: true,
  // },
  

  ///////////
  ///////////
  /// Profitability KPI ///
  ///////////
  ///////////

  // {
  //   id: RoutingEnum.ProfitabilityKPI,
  //   title: i18n.t("Menu.profitabilityKPI"),
  //   parentId: RoutingEnum.Home,
  //   showOnMenu: true,
  //   component: ProfitabilityKPIModule,
  //   href: ROUTE_PATHS.ProfitabilityKPI,
  // },

  // {
  //   id: RoutingEnum.ProfitabilityKPIOnboarding,
  //   title: i18n.t("ProfitabilityKPI.onBoardingHeader"),
  //   parentId: RoutingEnum.ProfitabilityKPI,
  //   showOnMenu: false,
  //   component: ProfitabilityKPIOnboarding,
  //   href: ROUTE_PATHS.ProfitabilityKPIOnboarding,
  // },
  // {
  //   id: RoutingEnum.FTPCalculator,
  //   parentId: RoutingEnum.ProfitabilityKPI,
  //   title: i18n.t("Menu.fTPCalculator"),
  //   showOnMenu: true,
  //   loginRequired: true,
  // },
  // {
  //   id: RoutingEnum.StandaloneCorporate,
  //   parentId: RoutingEnum.ProfitabilityKPI,
  //   title: i18n.t("Menu.standaloneCorporate"),
  //   showOnMenu: true,
  //   loginRequired: true,
  // },
  // {
  //   id: RoutingEnum.StandaloneMortgage,
  //   parentId: RoutingEnum.ProfitabilityKPI,
  //   title: i18n.t("Menu.standaloneMortgage"),
  //   showOnMenu: true,
  //   loginRequired: true,
  // },
  // {
  //   id: RoutingEnum.ProfitabilityDashboard,
  //   parentId: RoutingEnum.ProfitabilityKPI,
  //   title: i18n.t("Menu.profitabilityDashboard"),
  //   showOnMenu: true,
  //   loginRequired: true,
  // },
  {
    id: RoutingEnum.ScenarioFrontierReviewReport,
    parentId: RoutingEnum.ScenarioFrontierApprovalWorkflow,
    loginRequired: true,
    href: `${ROUTE_PATHS.ScenarioFrontierReviewReport}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    component: FrontierReportDetails,
    showOnMenu: false,
  },
  {
    id: RoutingEnum.ScenarioFrontierCreditandConcentration,
    title: i18n.t("ScenarioFrontier.lbCreditandConcentration"),
    parentId: RoutingEnum.ScenarioFrontier,
    showOnMenu: true,
    loginRequired: true,
  },
  {
    id: RoutingEnum.ScenarioFrontierIFRSCECL,
    title: i18n.t("ScenarioFrontier.lbIFRSCECL"),
    parentId: RoutingEnum.ScenarioFrontier,
    showOnMenu: true,
    loginRequired: true,
  },
  {
    id: RoutingEnum.ScenarioFrontierAssetQuality,
    title: i18n.t("ScenarioFrontier.lbAssetQuality"),
    parentId: RoutingEnum.ScenarioFrontier,
    showOnMenu: true,
    loginRequired: true,
  },
  {
    id: RoutingEnum.ScenarioFrontierApprovalWorkflow,
    title: i18n.t("ScenarioFrontier.lbApprovalWorkflow"),
    parentId: RoutingEnum.ScenarioFrontier,
    showOnMenu: true,
    loginRequired: true,
    component: ScenarioFrontierApprovalWorkflow,
    href: ROUTE_PATHS.ScenarioFrontierApprovalWorkflow,
  },
  {
    id: RoutingEnum.ScenarioFrontierReports,
    title: i18n.t("ScenarioFrontier.lbScenarioAndBudgeting"),
    parentId: RoutingEnum.ScenarioFrontier,
    loginRequired: true,
    href: ROUTE_PATHS.ScenarioFrontierReports,
    component: ScenarioFrontierReports,
  },
  {
    id: RoutingEnum.ScenarioFrontierNewReport,
    parentId: RoutingEnum.ScenarioFrontierReports,
    loginRequired: true,
    href: ROUTE_PATHS.ScenarioFrontierNewReport,
    component: FrontierNewReport,
  },
  {
    id: RoutingEnum.ScenarioFrontierReportDetails,
    parentId: RoutingEnum.ScenarioFrontierReports,
    loginRequired: true,
    href: `${ROUTE_PATHS.ScenarioFrontierReportDetails}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    component: FrontierReportDetails,
  },
  {
    id: RoutingEnum.ScenarioFrontierConfiguration,
    title: i18n.t("ScenarioFrontier.ttConfiguration"),
    parentId: RoutingEnum.ScenarioFrontier,
    showOnMenu: false,
    loginRequired: true,
    href: ROUTE_PATHS.ScenarioFrontierConfiguration,
    component: ScenarioFrontierConfiguration,
  },
  {
    href: ROUTE_PATHS.Scenarios,
    exact: true,
    component: Scenarios,
    title: i18n.t("Scenario.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.Scenarios,
    parentId: RoutingEnum.ScenarioFrontierRiskAppetiteDashboard,
  },
  {
    href: ROUTE_PATHS.AddScenario,
    exact: true,
    component: ScenariosForm,
    title: i18n.t("Scenario.formHeaderTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.AddScenario,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: ROUTE_PATHS.ControlFailure,
    exact: true,
    component: ControlFailures,
    title: i18n.t("ControlFailure.headerTitle"),
    permissions: [PERMISSION.LossEvent],
    loginRequired: true,
    id: RoutingEnum.ControlFailure,
    parentId: RoutingEnum.ScenarioFrontierRiskAppetiteDashboard,
  },
  {
    href: ROUTE_PATHS.AddControlFailure,
    exact: true,
    component: ControlFailureForm,
    title: i18n.t("ControlFailure.addHeaderTitle"),
    permissions: [PERMISSION.LossEvent],
    loginRequired: true,
    id: RoutingEnum.AddControlFailure,
    parentId: RoutingEnum.ControlFailure,
  },
  {
    href: `${ROUTE_PATHS.EditControlFailure}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ControlFailureForm,
    title: i18n.t("ControlFailure.addHeaderTitle"),
    permissions: [PERMISSION.LossEvent],
    loginRequired: true,
    id: RoutingEnum.EditControlFailure,
    parentId: RoutingEnum.ControlFailure,
  },
  {
    href: `${ROUTE_PATHS.ViewControlFailure}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ControlFailureView,
    permissions: [PERMISSION.LossEvent],
    loginRequired: true,
    id: RoutingEnum.ViewControlFailure,
    parentId: RoutingEnum.ControlFailure,
    title: "View Control Failure",
  },
  {
    href: ROUTE_PATHS.ScenrarioInvite,
    exact: true,
    component: ScenrarioInvite,
    title: i18n.t("ScenrariosAssessment.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ScenrarioInvite,
    parentId: RoutingEnum.ScenarioFrontierRiskAppetiteDashboard,
  },
  {
    href: `${ROUTE_PATHS.ViewScenario}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ScenarioView,
    title: i18n.t("Scenario.formHeaderTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ViewScenario,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: `${ROUTE_PATHS.ScenarioMitigation}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: ScenarioMitigationForm,
    title: i18n.t("ScenarioMitigation.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ScenarioMitigation,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: `${ROUTE_PATHS.ScenarioAppraisal}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: AppraisalForm,
    title: i18n.t("Appraisal.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ScenarioAppraisal,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: `${ROUTE_PATHS.EditScenario}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ScenariosForm,
    title: i18n.t("Scenario.formHeaderTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.EditScenario,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowMitigation}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: ScenarioMitigationView,
    title: i18n.t("ScenarioMitigation.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowMitigation,
    parentId: RoutingEnum.ApprovalWorkflow,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowAppraisal}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: AppraisalView,
    title: i18n.t("Appraisal.headerTitle"),
    permissions: [PERMISSION.Approver],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowAppraisal,
    parentId: RoutingEnum.ApprovalWorkflow,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowScenario}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ScenarioView,
    title: "",
    permissions: [PERMISSION.Approver],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowScenario,
    parentId: RoutingEnum.ScenarioFrontierApprovalWorkflow,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowControlFalure}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: ControlFailureView,
    title: "",
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowControlFalure,
    parentId: RoutingEnum.ScenarioFrontierApprovalWorkflow,
  },
  {
    href: `${ROUTE_PATHS.ScenarioMitigationView}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: ScenarioMitigationView,
    title: i18n.t("ScenarioMitigation.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ScenarioMitigationView,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: `${ROUTE_PATHS.ScenarioAppraisalView}/${ROUTE_DYNAMIC_VARIABLE.scenarioId}`,
    exact: true,
    component: AppraisalView,
    title: i18n.t("Appraisal.headerTitle"),
    permissions: [PERMISSION.ScenarioAssessment],
    loginRequired: true,
    id: RoutingEnum.ScenarioAppraisalView,
    parentId: RoutingEnum.Scenarios,
  },
  {
    href: ROUTE_PATHS.PortfolioRAROCNewReport,
    exact: true,
    component: EcapNewReport,
    title: i18n.t("RapmReport.headerTitle"),
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.PortfolioRAROCNewReport,
    parentId: RoutingEnum.PortfolioRAROCModule,
  },
  {
    href: `${ROUTE_PATHS.PortfolioRAROCReportDetails}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: EcapReportDetails,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.PortfolioRAROCReportDetails,
    parentId: RoutingEnum.PortfolioRAROCModule,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowPortfolioRAROC}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: EcapReportDetails,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowPortfolioRAROC,
    parentId: RoutingEnum.ApprovalWorkflow,
  },
  {
    href: ROUTE_PATHS.ECAPReportGroup,
    exact: true,
    component: EcapModuleReportGroup,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ECAPReportGroup,
    parentId: RoutingEnum.ECAPModule,
  },
  {
    href: ROUTE_PATHS.ECAPReports,
    exact: true,
    component: EcapReports,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.EcapReports,
    parentId: RoutingEnum.ECAPReportGroup,
  },
  {
    href: ROUTE_PATHS.ECAPNewReport,
    exact: true,
    component: EcapNewReport,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.EcapNewReport,
    parentId: RoutingEnum.EcapReports,
    title: i18n.t("EcapModule.titleNewReport"),
  },
  {
    href: `${ROUTE_PATHS.ECAPReportDetails}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: EcapReportDetails,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.EcapReportDetails,
    parentId: RoutingEnum.EcapReports,
  },
  {
    href: `${ROUTE_PATHS.ApprovalWorkflowECAPModule}/${ROUTE_DYNAMIC_VARIABLE.id}`,
    exact: true,
    component: EcapReportDetails,
    permissions: [],
    loginRequired: true,
    id: RoutingEnum.ApprovalWorkflowEcapModule,
    parentId: RoutingEnum.ApprovalWorkflow,
  },
  {
    href: ROUTE_PATHS.EcapLeaderOnboarding,
    exact: true,
    component: ECAPLeaderOnboarding,
    permissions: [PERMISSION.ClientAdmin],
    loginRequired: true,
    id: RoutingEnum.EcapLearderOnboarding,
    parentId: RoutingEnum.ECAPLeader,
    title: i18n.t("ECAPLeader.ttECAPLeaderConfiguration"),
  },
];

export const routes: Route[] = [...anonymousRouters, ...authorizedRouters];
